// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Cosmos DB Diagnostic Level
 */
export enum CosmosDbDiagnosticLevel {
  info = "info",
  debug = "debug",
  debugUnsafe = "debug-unsafe",
}
